import { KmsTypeFilterItemCheckbox } from "@kaltura/mediaspace-shared-types";
import { MenuItem } from "@kaltura/ds-react-components";
import { Check16Icon } from "@kaltura/ds-react-icons";
import { MenuItemProps } from "../types";

const SingleSelectionMenuItem = (props: MenuItemProps) => {
    const { option, isChecked, onChange, autoFocus, disabled = false } = props;

    return (
        <MenuItem
            role="menuitemradio"
            onClick={() => onChange(option as KmsTypeFilterItemCheckbox)}
            icon={isChecked(option.value) && <Check16Icon />}
            aria-checked={isChecked(option.value)}
            autoFocus={autoFocus}
            disabled={disabled}
        >
            <span className="kms-ds-channels-filter-menu-item-label">{option.label}</span>
        </MenuItem>
    );
};

export default SingleSelectionMenuItem;
